<template>
  <section class="ts-fields">
    <h2 class="fw-bold" :class="subline ? 'mb-1' : 'mb-4'">{{ title }}</h2>
    <p v-if="subline" class="ts-fields-subline mb-4">{{ subline }}</p>
    <div class="row g-3">
      <div v-for="field in fields" :key="field.id" class="col-12 col-sm-6 col-lg-4">
        <article class="ts-field-card h-100">
          <div class="ratio talentspace-field-photo">
            <div class="talentspace-field-image-clip">
              <img
                v-if="field.picture"
                class="ts-field-image w-100 h-100 object-fit-cover"
                :src="`${serverUrl}${field.picture}`"
                alt=""
                width="800"
                height="500"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          <div class="talentspace-field-label d-flex align-items-center justify-content-between gap-3">
            <div class="talentspace-field-copy text-start">
              <h3 class="fw-bold mb-1">
                <a
                  class="stretched-link ts-field-link"
                  href="#"
                  :aria-label="`${field.name}, ${formatCount(field.count)} ${unit}`"
                  @click.prevent="$emit('select', field)"
                >
                  {{ field.name }}
                </a>
              </h3>
              <div class="talentspace-field-count">
                <span class="talentspace-field-count-number">{{ formatCount(field.count) }}</span>
                {{ ' ' }}<span class="talentspace-field-count-unit">{{ unit }}</span>
              </div>
            </div>
            <span class="talentspace-field-arrow d-inline-flex flex-shrink-0 align-items-center justify-content-center" aria-hidden="true">
              <i class="bi bi-arrow-right"></i>
            </span>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { formatCount } from '@/helpers/formatCount';
import { SERVER_URL } from '@/config/constant';

export interface FieldCard {
  id: number
  name: string
  count: number
  // Photo configured per site in PAT, relative to SERVER_URL
  picture?: string
}

@Component
export default class TsFieldGrid extends Vue {
  @Prop({ required: true }) readonly title!: string;

  @Prop({ default: '' }) readonly subline!: string;

  @Prop({ default: () => [] }) readonly fields!: FieldCard[];

  @Prop({ default: '' }) readonly unit!: string;

  serverUrl = SERVER_URL;

  formatCount = formatCount;
}
</script>
